<div class="container">
  <h1>{{ welcomeComponent()?.title?.toUpperCase() }}</h1>
  <span>{{ welcomeComponent()?.subtitle }}</span>
</div>
